<template>
  <div>
    <el-card class="top-tool">
      <div class="system-list">
        <div :class="['system-item',{'checked':styleType===0}]" @click="projectType(0)">• 全部项目<span>({{projectNum.allVersion}}/{{projectNum.allProject}})</span></div>
        <div :class="['system-item',{'checked':styleType===1}]" @click="projectType(1)">• 新启动<span>({{projectNum.versionStartUp}}/{{projectNum.startUp}})</span></div>
        <div :class="['system-item',{'checked':styleType===2}]" @click="projectType(2)">• 进行中<span>({{projectNum.versionProcessing}}/{{projectNum.processing}})</span></div>
        <div :class="['system-item',{'checked':styleType===3}]" @click="projectType(3)">• 维护中<span>({{projectNum.versionMaintain}}/{{projectNum.maintain}})</span></div>
        <div :class="['system-item',{'checked':styleType===4}]" @click="projectType(4)">• 已结束<span>({{projectNum.versionClose}}/{{projectNum.close}})</span></div>
        <div :class="['system-item',{'checked':styleType===4}]" @click="projectType(5)">• 无版本<span>(0/{{projectNum.noVersion}})</span></div>
      </div>
    </el-card>
  </div>
</template>

<script>
let styleType = 0
export default {
  props:{
    projectNum:{
      type:Object,
      default:function(){
        return {

        }
      }
    }
  },
  data () {
    return {
      styleType: 0
    }
  },
  methods: {
    projectType: function (type) {
      this.styleType = type
      this.$emit('projectType', type);
    }
    // projectType (type) {
    //   this.$emit('projectType', type)
    //   //this.$router.push('/project-manage/projectManagerPannel')
    // },
    // start () {
    //   //this.$router.push('/project-manage/new-start/NewStart')
    // }

  },
}
</script>

<style scoped>
.top-tool >>> .el-card__body {
  display: flex;
  height: 30px;
}
.system-list {
  display: flex;
  margin-left: 50px;
}
.system-item {
  margin: 5px 10px;
  cursor: pointer;
}
.checked {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/project-manage/topMenu.vue